export function generatePrice(
  total_project_power,
) {
  let power = total_project_power;
  let price = 0;

  if (power >= 0 && power <= 10) {
    price = 400.0;
  } else if (power > 10 && power <= 30) {
    price = 600.0;
  } else if (power > 30 && power <= 50) {
    price = 800.0;
  } else if (power > 50 && power <= 75) {
    price = 1000.0
  } else {
    return null
  }

  return price;
}
